"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.stringWithPositions = void 0;
const escape_string_regexp_1 = __importDefault(require("escape-string-regexp"));
const stringWithPositions = (contents, replacements) => {
    const cursorPositions = Object.fromEntries(replacements.map(replacement => [replacement, []]));
    const regex = new RegExp(`(?:${replacements.map(replacement => `(${(0, escape_string_regexp_1.default)(replacement)})`).join('|')})`);
    let currentMatch;
    while ((currentMatch = regex.exec(contents))) {
        const offset = currentMatch.index;
        const matchLength = currentMatch[0].length;
        contents = contents.slice(0, offset) + contents.slice(offset + matchLength);
        for (const [i, val] of currentMatch.slice(1).entries()) {
            if (!val)
                continue;
            cursorPositions[replacements[i]].push(offset);
            break;
        }
    }
    return [contents, cursorPositions];
};
exports.stringWithPositions = stringWithPositions;
